import { createSelector } from '@reduxjs/toolkit';
import { fetchSuggestionsBySearchTerm } from '@/redux/api/discoverPageSuggestions';
import { getAuthToken } from '@/redux/modules/user';
import { getDeployment } from './config';
import { GlobalState } from '../rootReducer';

/* Action Types */
export const LOAD_DISCOVER_PAGE_SUGGESTIONS_FAIL = 'la/domain/items/LOAD_DISCOVER_PAGE_SUGGESTIONS_FAIL';
export const LOAD_DISCOVER_PAGE_SUGGESTIONS_SUCCESS = 'la/domain/items/LOAD_DISCOVER_PAGE_SUGGESTIONS_SUCCESS';

interface DefaultState {
    discoverPageSuggestions: {
        imageURL: string;
        title: string;
    }[];
}

/* reducer */
export const DEFAULT_STATE: DefaultState = {
    discoverPageSuggestions: [],
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case LOAD_DISCOVER_PAGE_SUGGESTIONS_FAIL:
            return {
                ...state,
                discoverPageSuggestions: [],
            };
        case LOAD_DISCOVER_PAGE_SUGGESTIONS_SUCCESS:
            return {
                ...state,
                discoverPageSuggestions: action.payload,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.discoverPageSuggestions;

export const getDiscoverPageSuggestions = createSelector(stateSelector, (state) => state.discoverPageSuggestions || []);

/* ACTION CREATORS */
export const fetchDiscoverPageSuggestions = (searchTerm: string) => async (dispatch: Function, getState: Function) => {
    const state = getState();
    const authToken = getAuthToken(state);
    const deployment = getDeployment(state);
    try {
        const response = await fetchSuggestionsBySearchTerm({ authToken, deployment, searchTerm });
        dispatch({
            payload: response.payload,
            type: LOAD_DISCOVER_PAGE_SUGGESTIONS_SUCCESS,
        });
    } catch (error) {
        dispatch({
            error: true,
            meta: { searchTerm },
            payload: error,
            type: LOAD_DISCOVER_PAGE_SUGGESTIONS_FAIL,
        });
    }
};
